import toast from 'components/Toast/dispatch';
import store from 'store';
import { ICustomerRole } from 'models/CustomerRole';

export const SelectCustomerIdIsArray = (customer?: ICustomerRole) => {

  const { user } = store.getState();

  const existSelectedCustomer: Array<string> | string = user?.selectedCustomerId!;

  if (!existSelectedCustomer) return;

  if (Array.isArray(user?.selectedCustomerId) && user?.selectedCustomerId!?.length > 1) {
    toast.info('Atenção', 'Selecione no topo da tela, na opção "Minhas empresas", apenas a empresa que deseja executar a ação e tente novamente.');
    return true;
  }

  if (customer && Array.isArray(customer)) {
    toast.info('Atenção', 'Selecione no topo da tela, na opção "Minhas empresas", apenas a empresa que deseja executar a ação e tente novamente.');
    return true;
  }
};